import { GetterTree } from "vuex";
import { RootState } from "../types";
import { OrganizationState } from "./types";

export const getters: GetterTree<OrganizationState, RootState> = {};
